import React from 'react';
import PropTypes from 'prop-types';

import DisclosureIcon from '../disclosure-icon';
import DisclosureItem from '../disclosure-item';
import IconBackground from '../icon-background';

const ListingDisclosures = ({ticketTraits = []}) => {
  return (
    <>
      {ticketTraits.map(({id, type, info}) =>
        id && info ? (
          <DisclosureItem key={id}>
            <IconBackground>
              <DisclosureIcon disclosureid={id} disclosuretype={type} color="#0774CA" />
            </IconBackground>
            <div className="RoyalBuildYourOrder__body_disclosures_disclosure__content">{info}</div>
          </DisclosureItem>
        ) : null
      )}
    </>
  );
};

ListingDisclosures.propTypes = {
  ticketTraits: PropTypes.array,
};

export default ListingDisclosures;
